
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Footer = () => {
    return (
        <>
            <Container>
                <Row>
                    <Col className='text-center'>
                        <p>© 2025 Michael Kaffel</p>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Footer